module.exports = __webpack_public_path__ + "img/saleThanks.f139769.webp";